import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import videojs from "video.js";
import "videojs-plus";
import "videojs-plus/dist/videojs-plus.css";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import initialQuery, { queryNFT } from "../../services/contracts";
import { toast } from "react-toastify";
import { initializeIBCChain, KeplrWallet } from "../../services/keplr";
import initializeTransaction, { mintNftTransaction } from "../../services/contractWrite";
import { longify } from "@cosmjs/stargate/build/queryclient";


const defaultPlayerOptions = {
  autoplay: true,
  muted: true,
  aspectRatio: "16:9",
  mobileView: false,
};

const Player = ({
  children,
  onPlayerInit,
  onPlayerDispose,

}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const data = useSelector((state) => state.module.list);
  const current = useSelector((state) => state.module._);
  const lesson = useSelector((state) => state.module.lesson);
  const [userAddress, setUserAddress] = useState();
  const [userWatchedVideos, setUserWatchedVideos] = useState([]);

  let currentModule = current.id;
  let currentVideo = current['lessons'] && current['lessons'][lesson.index].index + 1;
  let currentModuleName = current.title;
  const userWatchedVideo = useSelector((state) => state.module.userWatchedVideo)

  useEffect(() => {
    // console.log("Player useEffect 1");
    if (containerRef.current) {
      const videoEl = containerRef.current.querySelector("video");
      const playerOptions = {
        sources: [
          {
            src: lesson && lesson.url
          }

        ]
      }
      const player = videojs(videoEl, {
        ...defaultPlayerOptions,
        ...playerOptions
      });


      const playerEl = player.el();
      const flag = player.getChild("PlayToggleLayer").el();
      for (const child of containerRef.current.children) {
        if (child !== playerEl) {
          playerEl.insertBefore(child, flag);
        }
      }
      onPlayerInit && onPlayerInit(player);

      window.player = player;

      return () => {
        onPlayerDispose && onPlayerDispose(null);
        player.dispose();
      };
    }
  }, [onPlayerInit, onPlayerDispose]);


  useEffect(() => {
    // console.log("Player useEffect 2");

    const videoEl = containerRef.current.querySelector("video");

    const player = videojs(videoEl);
    player.src({ type: 'video/mp4', src: lesson?.url })

  }, [lesson])

  useEffect(() => {
    // console.log("Player useEffect 3");

    let userAddress = localStorage.getItem('ac');
    setUserAddress(userAddress);

    if (!userAddress) {
      // fetchWatchList();
      toast.error(
        <span className='toast'>Please connect keplr</span>,
        {
          position: "bottom-center",
        }
      );
    }
  }, [])

  useEffect(() => {
    // console.log("Player useEffect 4");

    if (userAddress && current?.id) {
      fetchWatchList();
    }
  }, [lesson, current,])
  // userWatchedVideos


  const fetchWatchList = () => {
    // console.log(current?.id);
    initialQuery(current?.id).then((res) => {
      // console.log(res);
      setUserWatchedVideos(res)
      dispatch({ type: "USER_WATCHED_VIDEO", value: res })
    });
  }

  const playerOptions = {
    sources: [
      {
        src: lesson && lesson.url
      }

    ]
  }

  const onCompleteVideo = async () => {
    if (typeof (current['lessons'] && current['lessons'][lesson.index] ? current['lessons'][lesson.index + 1] : current['lessons'][lesson.index]) !== 'undefined') {
      dispatch({ type: "CURRENT_LESSON_SET", value: current['lessons'] && current['lessons'][lesson.index] ? current['lessons'][lesson.index + 1] : current['lessons'][lesson.index] })
      if (userWatchedVideo.includes(String(lesson.index + 1)) === false) {
        toast.info(
          <span className='toast'>Transaction Initiated</span>,
          {
            position: "bottom-center",
          }
        );
        initializeTransaction(currentModule, currentVideo, (error, result) => {
          if (error) {
            console.log(error);
            toast.error(
              <span className='toast'>Transaction Failed</span>,
              {
                position: "bottom-center",
              }
            );
            return;
          }
          toast.success(
            <span className='toast'>Transaction Successful</span>,
            {
              position: "bottom-center",
            }
          );
          initialQuery(current?.id).then((res) => {

            dispatch({ type: "USER_WATCHED_VIDEO", value: res })
            setUserWatchedVideos(res)
          });
        })

      }
    }
    if (typeof (current['lessons'] && current['lessons'][lesson.index] ? current['lessons'][lesson.index + 1] : current['lessons'][lesson.index]) === 'undefined') {
      if (userWatchedVideo.includes(String(lesson.index + 1)) === false) {
        toast.info(
          <span className='toast'>Transaction Initiated</span>,
          {
            position: "bottom-center",
          }
        );
        console.log("Transaction Init");
        initializeTransaction(currentModule, currentVideo, (error, result) => {
          if (error) {
            console.log(error);
            toast.error(
              <span className='toast'>Transaction Failed</span>,
              {
                position: "bottom-center",
              }
            );
            return;
          }
          console.log("Transaction Suss");

          toast.success(
            <span className='toast'>Transaction Successful</span>,
            {
              position: "bottom-center",
            }
          );
          initialQuery(current?.id).then((res) => {
            dispatch({ type: "USER_WATCHED_VIDEO", value: res })
            setUserWatchedVideos(res)
          });
        })
      }

    }
  }

  return (
    <div className="player" ref={containerRef}>
      <video src={playerOptions.sources && playerOptions.sources[0] && playerOptions.sources[0].src} onEnded={onCompleteVideo} />
      {children}
    </div>
  );
}

export default Player;